<form [formGroup]="fG">
  @if(format) {
    <ejs-datetimepicker  [placeholder]="placeholder" [formControlName]="fCN" [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '')" [step]="step" [format]="format" [min]="min || undefined"></ejs-datetimepicker>
  } @else {
    <ejs-datetimepicker  [placeholder]="placeholder" [formControlName]="fCN" [cssClass]="cssClass + ' ' + (fG.controls[fCN].invalid && fG.controls[fCN].dirty ? 'e-error' : '')" [step]="step" [min]="min || undefined"></ejs-datetimepicker>
  }
</form>
